const BUTTON_ATTRIBUTE = 'data-show-more-button';
const BUTTON_SELECTOR = `[${BUTTON_ATTRIBUTE}]`;
const SHOW_ALL_CLASS = 'show-all-items';

class TruncateList {
  constructor($list, remainingItems) {
    this.button = $(
      `<li ${BUTTON_ATTRIBUTE}><a class="button-a">View ${remainingItems} more</a></li>`
    );
    this.$list = $list;

    this.initialize();
    this.attachEventHandlers();
  }

  initialize() {
    this.$list.append(this.button);
  }

  attachEventHandlers() {
    $('body').on('click', BUTTON_SELECTOR, this.showMoreItems);
  }

  showMoreItems(event) {
    const $button = $(event.currentTarget);
    $button.parent().addClass(SHOW_ALL_CLASS).end().remove();
  }
}

export default TruncateList;



// WEBPACK FOOTER //
// ./src/javascripts/TruncateList/ShowMoreButton.js